import { MoveFileModalComponent } from "./../accountant/modals/move-file-modal.component";
import { HotToastService } from "@ngneat/hot-toast";
import { DeleteConfirmationModalComponent } from "./../accountant/modals/delete-confirmation-modal.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { ChangeDetectorRef, Component, Input } from "@angular/core";

import { Conversation } from "../../conversations/panels/conversation.model";
import { FilesManagerService } from "../../files-manager/files-manager.service";
import { MomentModule } from "ngx-moment";
import { FilePreviewDirective } from "../common/file-preview.directive";
import { NgIf, NgFor, NgClass, CommonModule } from "@angular/common";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@Component({
  selector: "app-recent-files",
  templateUrl: "./recent-files.component.html",
  styleUrls: [
    "../../files-manager/files-manager.component.scss",
    "./recent-files.component.scss",
  ],
  imports: [CommonModule, BsDropdownModule, MomentModule, FilePreviewDirective],
})
export class RecentFilesComponent {
  current_conversation: Conversation;
  staffsFiles = [];
  clientsFiles = [];
  isLoading = false;

  bsModalRef: any;

  selectedFile: {
    filename: string;
    etag: string;
  };

  @Input()
  set conversation(value: Conversation) {
    if (value !== undefined) {
      this.current_conversation = value;
      this.getRecentFiles();
      this.cdr.detectChanges();
    }
  }

  constructor(
    private filesManagerService: FilesManagerService,
    private modalService: BsModalService,
    public toastr: HotToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  getRecentFiles() {
    if (this.current_conversation == null) {
      return;
    }

    this.isLoading = true;
    // fetches the files featured in Recent files
    this.filesManagerService
      .getRecentFiles(this.current_conversation.id)
      .subscribe((res: any) => {
        const staff = res["staff"];
        const client = res["client"];

        if (staff.length >= 5 && client.length >= 5) {
          this.staffsFiles = staff.slice(0, 5);
          this.clientsFiles = client.slice(0, 5);
        } else {
          let slots = 10;
          if (staff.length < 5) {
            slots = slots - staff.length;
            this.staffsFiles = staff;
            this.clientsFiles = client.slice(0, slots - 1);
          } else {
            slots = slots - client.length;
            this.clientsFiles = client;
            this.staffsFiles = staff.slice(0, slots - 1);
          }
        }
        this.isLoading = false;
      });
  }

  public openDeleteConfirmationModal(filename: string, fileEtag: string) {
    const initialState = {
      displayName: filename,
    };

    const deleteModal = this.modalService.show(
      DeleteConfirmationModalComponent,
      { initialState },
    );
    deleteModal.content.onClose.subscribe((confirmed) => {
      if (confirmed) {
        this.deleteFile(fileEtag);
      }
    });
  }

  deleteFile(uuid: string) {
    this.filesManagerService
      .deleteFile(this.current_conversation.id, uuid)
      .then(
        (result) => {
          this.toastr.success("File deleted successfully.");
          this.getRecentFiles();
        },
        (error) => {
          this.toastr.error("Something went wrong when deleting the file.");
        },
      );
  }

  public openModalMoveFile(filename: string, fileEtag: string) {
    const initialState = {
      currentConversationID: this.current_conversation.id,
      fileDetails: {
        filename: filename,
        etag: fileEtag,
      },
    };

    const moveFileModal = this.modalService.show(MoveFileModalComponent, {
      initialState,
    });
    moveFileModal.content.onClose.subscribe((target_uuid: any) => {
      // target_uuid can be false if the modal was just closed
      if (!target_uuid) {
        moveFileModal.hide();
      }

      this.filesManagerService
        .moveFile(this.current_conversation.id, {
          file: fileEtag,
          folder: target_uuid,
        })
        .then(
          (result) => {
            console.log("moved successfully");
            moveFileModal.hide();
            this.toastr.success(`File ${filename} successfully moved`);
          },
          (error) => {
            moveFileModal.hide();
            this.toastr.error("Something went wrong when moving the file.");
          },
        );
    });
  }

  openRenameModal(template: any, filename: string, etag: string) {
    this.selectedFile = { filename, etag };
    this.openModal(template);
  }

  public openModal(template: any) {
    this.bsModalRef = this.modalService.show(template);
  }

  renameFile(newName: string, fileEtag: string) {
    this.filesManagerService
      .renameFile(this.current_conversation.id, fileEtag, newName)
      .then(
        (result) => {
          this.bsModalRef.hide();
          this.toastr.success("File renamed successfully.");
          this.getRecentFiles();
        },
        (error) => {
          this.bsModalRef.hide();
          this.toastr.error("Something went wrong when renaming the file.");
        },
      );
  }
}
